<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import InfoBannerTitle from "./InfoBannerTitle.svelte";
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import Button from "./Button.svelte";

	export let image: string | undefined = undefined;
	export let title: string;
	export let textBlockPosition: "left" | "right" = "left";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="relative z-10 h-auto w-full p-3 sm:p-5 md:px-[4.375rem] md:py-[3.75rem] lg:h-[61.25rem]">
	{#if image}
		<StaticPicture
			{image}
			alt={title}
			width={1920}
			height={1080}
			imgClass="h-[37.5rem] lg:h-[61.25rem] absolute top-0 lg:top-0 w-full object-cover"
			class="absolute inset-0 -z-10"
		/>
	{/if}

	<div
		class="container flex flex-col items-center justify-between lg:mt-0 lg:h-full lg:flex-row lg:items-stretch lg:gap-10"
	>
		<div
			use:flyInOnScroll
			class="relative flex h-full w-full max-w-[49.125rem] flex-col justify-between p-4 max-lg:mt-80 sm:p-5 md:px-[3.625rem] md:pb-16 md:pt-[4.625rem] lg:max-w-[min(50%,49.125rem)] {textBlockPosition ===
			'left'
				? 'justify-self-start'
				: 'justify-self-end lg:ml-auto'}"
		>
			<InfoBannerTitle {title} className="px-4" />
			<slot name="content" />
			<div class="absolute inset-0 -z-10 bg-white/90 backdrop-blur"></div>
		</div>
		{#if $$slots.button}
			<Button animated class="mx-auto self-end text-left max-lg:max-w-full lg:mr-0" on:click>
				<slot name="button" />
			</Button>
		{/if}
	</div>
</div>
